/** Grep the browser console for this prefix to match toasts to log lines. */
const TOAST_TRACE_LOG_PREFIX = '[FamilyFinance:toast-trace]';

/**
 * New UTC-second timestamp (compact) for the human-readable segment.
 */
function utcDateTimeCompact(): { date: string; time: string } {
  const n = new Date();
  const y = n.getUTCFullYear();
  const m = String(n.getUTCMonth() + 1).padStart(2, '0');
  const d = String(n.getUTCDate()).padStart(2, '0');
  const h = String(n.getUTCHours()).padStart(2, '0');
  const min = String(n.getUTCMinutes()).padStart(2, '0');
  const s = String(n.getUTCSeconds()).padStart(2, '0');
  return { date: `${y}${m}${d}`, time: `${h}${min}${s}` };
}

function randomHexSuffix(length: number): string {
  try {
    const c = globalThis.crypto;
    if (c && typeof c.getRandomValues === 'function') {
      const arr = new Uint8Array(Math.ceil(length / 2));
      c.getRandomValues(arr);
      return Array.from(arr, (b) => b.toString(16).padStart(2, '0'))
        .join('')
        .slice(0, length)
        .toUpperCase();
    }
  } catch {
    // fall through
  }
  return Math.random()
    .toString(16)
    .replace(/^0\./, '')
    .padEnd(length, '0')
    .slice(0, length)
    .toUpperCase();
}

/**
 * Client-generated **frontend trace id** for toasts: same value is logged to the
 * browser console (see `[FamilyFinance:toast-trace]`) so you can align UI reports
 * with DevTools, similar to `request_id` in API logs. Not an HTTP status code.
 *
 * Format: `FE-YYYYMMDD-HHmmssZ-HEX` (UTC clock + 6-hex disambiguation).
 * Legacy `FF-…` values may still appear in older session quotes.
 */
export function nextClientToastCode(): string {
  const { date, time } = utcDateTimeCompact();
  const code = `FE-${date}-${time}Z-${randomHexSuffix(6)}`;
  try {
    if (process.env.NODE_ENV === 'test') {
      // Avoid noising test console; trace format is still asserted in tests
    } else {
      // eslint-disable-next-line no-console -- explicit support correlation
      console.info(TOAST_TRACE_LOG_PREFIX, code, { t: new Date().toISOString() });
    }
  } catch {
    // ignore
  }
  return code;
}
